import { Subject } from 'rxjs'

/**
 * this is player.one('play')
 * indicating the first start playback for a content
 */
export const playbackStarted$ = new Subject()
